/**
 * Konstante für das jüngste übergebene Projekt – wird auf der Startseite
 * angezeigt ("Unsere neueste Installation").
 *
 * REGELMÄSSIG PFLEGEN: Bei jeder neuen Anlagen-Übergabe diese Werte
 * aktualisieren. URL/Bild sind optional; wenn nicht gesetzt, wird ein
 * Platzhalter aus /images/ verwendet.
 *
 * `dateIso` muss ISO-8601 sein (YYYY-MM-DD), damit Schema.org-Markups
 * und sortierte Listen sauber funktionieren.
 */
export const LATEST_PROJECT = {
  /** Anlagenleistung in kWp (Zahl, ohne Einheit) */
  kwp: 12,
  /** Stadt oder Ortsteil – muss zu /standorte/<slug> passen, wenn linkable */
  city: "Wiesloch",
  /** Optionaler Stadt-Slug für interne Verlinkung. Setze auf null, wenn keine Detailseite existiert. */
  citySlug: "wiesloch" as string | null,
  /** Übergabe-Datum im ISO-8601-Format (YYYY-MM-DD) */
  dateIso: "2026-05-05",
  /** Für die Anzeige formatiert (z. B. "5. Mai 2026"); manuell aktualisieren. */
  dateLabel: "5. Mai 2026",
  /** Optionales Hero/Vorschaubild – relativ zu /public/. Fallback siehe Komponente. */
  image: "/images/AdobeStock_688195352.webp",
  /** Optionaler Speicher in kWh */
  storageKwh: 10,
  /** Kurzbeschreibung in 1-2 Sätzen */
  description:
    "Einfamilienhaus mit Süd-West-Ausrichtung, Wärmepumpe und Wallbox. Familie spart jährlich rund 2.400 € an Stromkosten.",
} as const;

export type LatestProject = typeof LATEST_PROJECT;
